import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    styleUrls: ['./page404.component.scss'],
    standalone: false
})
export class Page404Component implements OnInit {

  public targetUrl = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private location: Location) { }

  /**
   * OnInit hook
   */
  ngOnInit() {
    // if "url" is available in query-params, mask the window.location with "url"
    // This way, 404 path will not be visible in address bar
    const targetUrl = this.activatedRoute.snapshot.queryParams['url'];
    if (targetUrl) {
      this.targetUrl = targetUrl;
      this.location.replaceState(targetUrl);
    }
  }

}
